import { useTranslation } from 'react-i18next';
import './RoleSelectionDialog.css';
import format from 'date-fns/format';

const RoleCard = ({ data, handleSelectRole, isSelected }) => {
    const { t } = useTranslation();

    return (
        <div
            disabled={isSelected}
            className={`role-card-container ${isSelected ? 'selected' : ''}`}
            onClick={isSelected ? () => {} : () => handleSelectRole()}
        >
            <div className="role-card-title">{isSelected ? `${data?.roleName} (Selected)` : data?.roleName}</div>
            <div className="role-card-detail">{data?.functionName}</div>
            <div className="role-card-status">{data?.orgName}</div>
        </div>
    );
};

export default RoleCard;
